@use "variables" as *;

.mainContainer {
  width: 100%;
  height: 100%;
  display: flex;
}

.noSelectionDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: $spacing-xl $spacing-l 0 $spacing-l;
  overflow: auto;
}

.shortcutsGrid {
  overflow: visible !important;
}

.publicCollectionCard {
  width: 100%;
  margin-bottom: $spacing-xxl;
  white-space: pre-wrap;
  flex-shrink: 0;
  .publicCollectionName {
    text-align: center;
    font-size: $fontSize-m;
    font-weight: bold;
    margin: $spacing-s;
  }
  .publicCollectionDescription {
    text-align: left;
    font-size: $fontSize-s;
    margin: $spacing-s;
  }
}

.shortcutsTitle {
  font-size: $fontSize-ml;
  font-weight: bold;
  margin: $spacing-s $spacing-s $spacing-xl $spacing-s;
  text-align: center;
}

.mainDiv {
  padding: 0 $spacing-s 0 $spacing-m;
  display: flex;
  flex-grow: 1;
  overflow: auto;
}

.albumImageCard {
  position: relative;
  flex-shrink: 0;
  align-self: center;
  aspect-ratio: 1/1;
  border-radius: 4px !important;
  margin-top: $spacing-m;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.albumImage {
  width: 100%;
  height: 100%;
}

.reservedBox {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.4;
  z-index: 90;
  .reservedText {
    text-align: center;
    font-size: $fontSize-xl;
    font-weight: bolder;
    text-transform: uppercase;
  }
}

.list {
  flex-grow: 1;
  padding-top: $spacing-m !important;
}

.mobileList {
  flex-grow: 1;
}

.firstItemCard {
  margin: 0 $spacing-s $spacing-s;
}

.itemCard {
  margin: $spacing-s;
}

.lastItemCard {
  margin: $spacing-s $spacing-s $spacing-m $spacing-s;
}

.firstItemCardMobile {
  margin: 0 0 $spacing-s 0;
}

.itemCardMobile {
  margin: $spacing-s 0 $spacing-s 0;
}

.lastItemCardMobile {
  margin: $spacing-s 0 $spacing-m 0;
}

.cardDiv {
  padding: $spacing-m;
}

.tracksHeader {
  width: 100%;
  margin-top: $spacing-s;
}

.trackList {
  max-width: $big-album-image-size;
  width: 100%;
  margin-top: $spacing-s;
  margin-bottom: $spacing-m;
  z-index: 1000;
}

.trackListMobile {
  width: 100%;
  margin-top: $spacing-s;
  margin-bottom: $spacing-m;
}

.albumId {
  font-size: $fontSize-xs;
  padding: 0 $spacing-s $spacing-s $spacing-s;
  text-align: end;
}

.loadingStack {
  width: 100%;
  align-self: center;
  padding-left: 20%;
  padding-right: 20%;
  font-size: $fontSize-m;
  font-weight: bolder;
  text-align: center;
}

.progressBar {
  border-radius: 5px;
}
